<template>
  <div id="expense-type-form" class="group-setup">
    <v-progress-linear
      indeterminate
      color="blue darken-2"
      v-if="loading"
    ></v-progress-linear>
    <v-layout row v-if="errors">
      <v-flex>
        <Alert @dismissed="onDismissed" :text="errors"></Alert>
      </v-flex>
    </v-layout>

    <v-form ref="expenseTypeForm" v-model="valid" v-if="!loading">
      <v-row>
        <v-col cols="6" sm="6">
          <v-col class="pa-0 ma-0">
            <p class="text-title">Expense Type Name</p>
          </v-col>
          <v-text-field
            outlined
            dense
            v-model="formData.name"
            required
            clearable
            placeholder="Expense Type Name"
          ></v-text-field>
        </v-col>

        <v-col cols="6" md="4" sm="6">
          <v-col class="pa-0 ma-0">
            <p class="text-title">GL Account</p>
          </v-col>
          <v-col class="pa-0 ma-0">
            <v-autocomplete
              v-model="formData.gl_account_id"
              :items="GLAccounts"
              item-text="title"
              item-value="id"
              outlined
              dense
              clearable
              :rules="[rules.required]"
              :loading="isFetchingGLAccounts"
              :filter="() => true"
              @update:search-input="(searchTerm) => onSearchAccount(searchTerm)"
            ></v-autocomplete>
          </v-col>
        </v-col>

        <v-col cols="12" sm="12">
          <v-col class="pa-0 ma-0">
            <p class="text-title">Description</p>
          </v-col>
          <v-textarea
            v-model="formData.description"
            placeholder="Description"
            outlined
            dense
            auto-grow
          ></v-textarea>
        </v-col>

        <v-col cols="12">
          <v-card-actions>
            <v-btn
              color="primary"
              large
              @click="submitForm"
              v-if="
                (mode === 'edit' && hasPermission('expense_types.edit')) ||
                  (mode != 'edit' && hasPermission('expense_types.create'))
              "
            >
              {{
                mode === "edit" ? "Update Expense Type" : "Create Expense Type"
              }}
            </v-btn>
          </v-card-actions>
        </v-col>
      </v-row>
    </v-form>
  </div>
</template>

<script>
// import Alert from "@/components/shared/Alert";
import { ExpenseService } from "@/services/expense-service.js";
import { checkError } from "@/config/errors.js";
import { GLTransactionService } from "@/services/GLTransaction-service.js";
import { createNamespacedHelpers } from "vuex";
const { mapGetters } = createNamespacedHelpers("auth");

export default {
  name: "ExpenseTypeForm",
  props: {
    formData: { type: Object, required: true },
    mode: { type: String, required: true },
    id: { type: String, default: null },
    proploading: { type: Boolean, default: false },
  },
  data() {
    return {
      loading: this.proploading,
      valid: false,
      errors: null,
      isFetchingGLAccounts: false,
      accountSearchTimeout: null,
      GLAccounts: [],
      rules: {
        required: (value) => !!value || "This field is required.",
      },
    };
  },
  methods: {
    async submitForm() {
      if (!this.$refs.expenseTypeForm.validate()) return;
      this.loading = true;
      try {
        if (this.mode === "create") {
          await ExpenseService.createExpenseType(this.formData);
        } else {
          await ExpenseService.updateExpenseType(this.id, this.formData);
        }
        this.$router.push({ name: "ExpenseTypeList" });
      } catch (error) {
        console.error(error);
        let data = error.response.data;
        this.errors = checkError.errorFormatting(data);
      } finally {
        this.loading = false;
      }
    },

    async onSearchAccount(searchTerm) {
      try {
        clearTimeout(this.accountSearchTimeout);
        this.isFetchingGLAccounts = true;
        this.accountSearchTimeout = setTimeout(async () => {
          const response = await GLTransactionService.getAccountsByTitle(
            searchTerm
          );
          this.GLAccounts = response.data.data.original;
        }, 300);
      } catch (error) {
        console.error("Error fetching accounts:", error);
      } finally {
        this.isFetchingGLAccounts = false;
      }
    },

    onDismissed() {
      this.errors = null;
    },
  },
  computed: {
    ...mapGetters({
      hasPermission: "hasPermission",
    }),
  },
  watch: {
    proploading(newVal) {
      this.loading = newVal;
    },
  },
};
</script>
